import React from "react";
import { Button } from "repoV2/components/common/Button";
import { getComplimentaryHexColorFromRgbCssString } from "repoV2/features/Common/modules/Colors/utils/rgbColors.utils";
import { classNames } from "repoV2/utils/common/render/classNames";
import { ISubmitButtonProps } from "./CheckoutButton.interfaces";
import { useCheckoutThemeContext } from "../CheckoutThemeContextProvider";
import styles from "./CheckoutButton.module.scss";

const CheckoutButton: React.FC<ISubmitButtonProps> = props => {
    const { type, onClick, children, className, disabled } = props;
    const { colors } = useCheckoutThemeContext();
    const { color1 } = colors;
    const btnTextColor = getComplimentaryHexColorFromRgbCssString({
        rgbCssString: color1,
    });
    return (
        <Button
            className={classNames(styles.SubmitBtn, className)}
            style={{ color: btnTextColor, background: color1 }}
            type={type}
            onClick={onClick}
            disabled={disabled}
        >
            {children}
        </Button>
    );
};
export default CheckoutButton;
